import { Injectable, NgZone } from '@angular/core';
import {Subject} from "rxjs/Subject";

@Injectable()
export class DragService {

  public static DRAG_TYPE = {
    TIMELINE_MOVE: 'timeline_move',
    CLIP_MOVE: 'clip_move',
    CLIP_EXTEND_RIGHT: 'clip_extend_right',
    CLIP_EXTEND_LEFT: 'clip_extend_left',
  };

  public onDragMouseDown = new Subject();
  public onDragMouseUp = new Subject();

  private dragElement = null;
  private dragStartPositions = null;
  private dragType = null;
  private mouseDownFn = null;
  private mouseUpFn = null;
  private mouseMoveFn = null;
  private mouseMoveBindedFn = null;

  public waveFormElementRef = null;

  static getClientXFromEvent(event) {
    return event.changedTouches ? event.changedTouches[0].clientX : event.clientX;
  }

  static getClientYFromEvent(event) {
    return event.changedTouches ? event.changedTouches[0].clientY : event.clientY;
  }

  constructor(private zone: NgZone) {

    // Subscribe on MouseDown event
    this.onDragMouseDown.subscribe((event) => {

      // If the dragElement is null or no callback is missing then no action needed
      if (this.dragElement === null || this.mouseDownFn === null) {
        return;
      }

      // Remove mousemove event if its attached before
      if (this.mouseMoveBindedFn) {
        window.document.removeEventListener('mousemove', this.mouseMoveBindedFn);
        window.document.removeEventListener('touchmove', this.mouseMoveBindedFn);
      }

      // Subscribe on mouseMove event and run the callback function
      this.zone.runOutsideAngular(() => {
        this.mouseMoveBindedFn = this.mouseMoveFn.bind(this);
        window.document.addEventListener('mousemove', this.mouseMoveBindedFn);
        window.document.addEventListener('touchmove', this.mouseMoveBindedFn);
      });

      this.mouseDownFn(event);
    });

    // Subscribe on MouseUp event
    this.onDragMouseUp.subscribe((event) => {

      // If the dragElement is null or no callback is missing then no action needed
      if (this.dragElement === null || this.mouseUpFn === null) {
        return;
      }

      // UnSubscribe from mouseMove event and run the callback function
      window.document.removeEventListener('mousemove', this.mouseMoveBindedFn);
      window.document.removeEventListener('touchmove', this.mouseMoveBindedFn);

      const relativeMovement = this.calculateRelativeXMovement(event);
      this.mouseUpFn(event, relativeMovement);

      this.dragElement = null;
    });

  }

  /*
   * Calculate this relative X movement on the drag Element based on his start position
   */
  public calculateRelativeXMovement(event) {
    return DragService.getClientXFromEvent(event) - this.dragStartPositions.x;
  }

  public getPositionX(event, boundingBox) {
    return Math.min(boundingBox.right,
        Math.max(boundingBox.left, this.dragStartPositions.element.x + this.calculateRelativeXMovement(event)))
  }

  /*
   * Set all the necessary callback functions
   */
  setCallbacks(mouseMoveFn, mouseDownFn, mouseUpFn) {
    this.mouseDownFn = mouseDownFn;
    this.mouseMoveFn = mouseMoveFn;
    this.mouseUpFn = mouseUpFn;
  }

  setMouseMove(mouseMoveFn) {
    this.mouseMoveFn = mouseMoveFn;
  }

  setMouseDown(mouseDownFn) {
    this.mouseDownFn = mouseDownFn;
  }

  setMouseUp(mouseUpFn) {
    this.mouseUpFn = mouseUpFn;
  }

  setDragElement(clip, dragStartPositions = null, dragType = DragService.DRAG_TYPE.CLIP_MOVE) {
    this.dragElement = clip;
    this.dragStartPositions = dragStartPositions;
    this.dragType = dragType;
  }

  getDragType() {
    return this.dragType;
  }

  getDragElement() {
    return this.dragElement;
  }

  getDragStartPositions() {
    return this.dragStartPositions;
  }
}



// WEBPACK FOOTER //
// ./src/app/storyboard/shared/drag.service.ts